// extracted by mini-css-extract-plugin
export default {"resizableContainer":"ResizableHeader_resizableContainer__AczdD","resizableScrollContainer":"ResizableHeader_resizableScrollContainer__8KaKp","footer":"ResizableHeader_footer__Ondib"};